module.exports = __webpack_public_path__ + "static/img/limit_icon@3x.bb78ad4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/active/limit_icon@3x.png
// module id = T5RG
// module chunks = 1